<template>
  <div>
    <v-card flat>
      <v-card-title>
        <label class="primary--text px-5 font-weight-bold info-page-title ma-auto">{{ $t(`label.faq`) }}</label>
      </v-card-title>
    </v-card>
    <v-card class="info-page-card">
      <v-expansion-panels accordion v-model="panel">
        <v-expansion-panel v-for="(info, i) in faqContent" :key="i">
          <v-expansion-panel-header class="font-weight-bold text-uppercase">{{ info.title }}</v-expansion-panel-header>
          <v-expansion-panel-content class="py-4 info-expension-panel-content">
            <div v-for="content in info.content" :key="content.title">
              <p class="text-capitalize font-weight-bold info-expension-panel-content-title mb-1" v-html="content.title"></p>
              <p v-html="content.desc"></p>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </div>
</template>
<script>
import { locale, uiHelper } from "@/util";
export default {
  name: 'faq',
  data: () => ({
    panel: 0,
    faqContent: [
      {
        title: locale.getMessage(`info.info_faq`),
        content: [
          {
            title: locale.getMessage(`info.info_faq_a_title`),
            desc: locale.getMessage(`info.info_faq_a_desc`)
          },
          {
            title: locale.getMessage(`info.info_faq_b_title`),
            desc: locale.getMessage(`info.info_faq_b_desc`)
          },
          {
            title: locale.getMessage(`info.info_faq_c_title`),
            desc: locale.getMessage(`info.info_faq_c_desc`)
          },
          {
            title: locale.getMessage(`info.info_faq_d_title`),
            desc: locale.getMessage(`info.info_faq_d_desc`)
          },
          {
            title: locale.getMessage(`info.info_faq_e_title`),
            desc: locale.getMessage(`info.info_faq_e_desc`)
          },
          {
            title: locale.getMessage(`info.info_faq_f_title`),
            desc: locale.getMessage(`info.info_faq_f_desc`)
          },
          {
            title: locale.getMessage(`info.info_faq_g_title`),
            desc: locale.getMessage(`info.info_faq_g_desc`)
          }
        ]
      }
    ]
  }),
  mounted() {
    this.metaTag()
  },
  methods: {
    metaTag() {
      const currentUrl = window.location.href;
      const domainWithProtocol = currentUrl.split('/')[2];
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '');
      const path = window.location.pathname;
      const cleanPath = path.replace(/\/(en-BD|bn-BD|en-IN|hi-IN|en-NP|ne-NP)/i, '');
      const Links = `https://${domain}${cleanPath}`;
      const Linksen = `https://${domain}/en-BD${cleanPath}`;
      const Linksbn = `https://${domain}/bn-BD${cleanPath}`;
      const Linksenin = `https://${domain}/en-IN${cleanPath}`;
      const Linksenhi = `https://${domain}/hi-IN${cleanPath}`;
      const Linksenennp = `https://${domain}/en-NP${cleanPath}`;
      const Linksennenp = `https://${domain}/ne-NP${cleanPath}`;

      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)
      uiHelper.setHreflangLinksenin(Linksenin)
      uiHelper.setHreflangLinkshi(Linksenhi)
      uiHelper.setHreflangLinksennp(Linksenennp)
      uiHelper.setHreflangLinksnenp(Linksennenp)
    }
  }
}
</script>
